import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { UpsellService } from '@app/shared/+state/shared/upsell.service';
import { map, take } from 'rxjs/operators';

export const CanSeeMyBusinessGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const upsellService = inject(UpsellService);

  return upsellService.myBusinessEnabled$.pipe(
    take(1),
    map((myBusinessEnabled) => {
      if (!myBusinessEnabled) {
        const redirectPath = route.data.redirectPath ?? '/operations';
        return router.createUrlTree([redirectPath]);
      }
      return true;
    })
  );
};
